import React from 'react'
import { Input, Radio, DatePicker } from 'ui/styled'
import { Form, Row, Col } from 'antd'
import { Label } from 'pages/Ticket/styled'
import DrugListUpdateFieldsAttachment from './DrugListUpdateFieldsAttachment'

const { Item } = Form
const { Group } = Radio

const actionOptions = [
  { label: 'Add', value: 'addition' },
  { label: 'Remove', value: 'removal' }
]

const DrugListUpdateFields = ({ form, resource }) => (
  <>
    <Row>
      <Col span={11}>
        <Label required>Drug List Name</Label>
        <Item
          name="drug_list_name"
          rules={[{ required: true, message: 'Drug List Name is required' }]}
        >
          <Input />
        </Item>
      </Col>
      <Col span={11} offset={2}>
        <Label required>Medication Name</Label>
        <Item
          name="medication_name"
          rules={[{ required: true, message: 'Medication Name is required' }]}
        >
          <Input />
        </Item>
      </Col>
    </Row>
    <Row>
      <Col span={11}>
        <Label required>NDC</Label>
        <Item
          name="ndc"
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value || getFieldValue('gpi')) {
                  return Promise.resolve()
                }
                return Promise.reject(
                  new Error('Either NDC or GPI is required')
                )
              }
            })
          ]}
        >
          <Input />
        </Item>
      </Col>
      <Col span={11} offset={2}>
        <Label required>GPI</Label>
        <Item
          name="gpi"
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value || getFieldValue('ndc')) {
                  return Promise.resolve()
                }
                return Promise.reject(
                  new Error('Either NDC or GPI is required')
                )
              }
            })
          ]}
        >
          <Input />
        </Item>
      </Col>
    </Row>
    <Row>
      <Col span={11}>
        <Label required>Action</Label>
        <Item
          name="action"
          rules={[{ required: true, message: 'Action is required' }]}
        >
          <Group options={actionOptions} />
        </Item>
      </Col>
      <Col span={11} offset={2}>
        <Label required>Date</Label>
        <Item
          name="date"
          rules={[{ required: true, message: 'Date is required' }]}
        >
          <DatePicker />
        </Item>
      </Col>
    </Row>
    <Label>Attachment</Label>
    <DrugListUpdateFieldsAttachment form={form} resource={resource} />
  </>
)

export default DrugListUpdateFields
